import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
import { Link, useSearchParams } from "react-router-dom";
import { dbService } from "../firebase";
// source
import ArrowBack from "../assets/icons/arrow_back.svg";
import ArrowEast from "../assets/icons/east.svg";
import StartPoint from "../assets/icons/startPoint.svg";
import Elevator from "../assets/icons/elevator.svg";
import North from "../assets/icons/north.svg";
import KakaoIcon from "../assets/icons/kakaoIcon.svg";
import EndPoint from "../assets/icons/endPoint.svg";
import ShuttleIcon from "../assets/icons/shuttle.svg";
import BtnSeeMap from "../assets/icons/btnSeeMap.svg";
import BtnSeePath from "../assets/icons/btnSeePath.svg";
import DeleteMiniMap from "../assets/buttons/clear_minimap.svg";
import { useTranslation } from "react-i18next";
import PathList from "./PathList";
const { kakao } = window;

const Path = () => {
  const { t, i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const transport = searchParams.get("transport");
  const startPoint = JSON.parse(sessionStorage.getItem("startPoint"));
  const endPoint = JSON.parse(sessionStorage.getItem("endPoint"));
  console.log("sp: ", startPoint);
  console.log("ep: ", endPoint);
  const [endShuttleInfo, setEndShuttleInfo] = useState({
    name: { "ko-KR": "", "en-US": "" },
  });
  const [startShuttleInfo, setStartShuttleInfo] = useState();

  const getShuttles = async () => {
    const dbShuttles = await dbService.collection("shuttle").get();
    dbShuttles.docs.forEach((s) => {
      const place = s.data();
      if (place?.region === startPoint?.region) {
        place.coords = {
          x: new kakao.maps.LatLng(place.latlng.x, place.latlng.y)
            .toCoords()
            .getX(),
          y: new kakao.maps.LatLng(place.latlng.x, place.latlng.y)
            .toCoords()
            .getY(),
        };
        setStartShuttleInfo(place);
      }
      if (place?.region === endPoint?.region) {
        place.coords = {
          x: new kakao.maps.LatLng(place.latlng.x, place.latlng.y)
            .toCoords()
            .getX(),
          y: new kakao.maps.LatLng(place.latlng.x, place.latlng.y)
            .toCoords()
            .getY(),
        };
        setEndShuttleInfo(place);
      }
    });
  };
  useEffect(() => {
    getShuttles();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [isMapVisible, setIsMapVisible] = useState(false);
  const [minimap, setMinimap] = useState("");
  const [height, setHeight] = useState("");
  const [description, setDescription] = useState("");
  const [pathDetails, setPathDetails] = useState([]);

  const kakaoLink = `https://map.kakao.com/?map_type=TYPE_MAP&target=walk&rt=${
    startPoint.coords?.x
  },${startPoint.coords?.y},${endPoint.coords?.x},${endPoint.coords?.y}&rt1=${
    startPoint.name[i18n.language]
  }&rt2=${endPoint.name[i18n.language]}`;

  const makeKakaoLink = (
    startX,
    startY,
    endX,
    endY,
    method, // traffic, walk
    startName,
    endName
  ) => {
    return `https://map.kakao.com/?map_type=TYPE_MAP&target=${method}&rt=${startX},${startY},${endX},${endY}&rt1=${startName}&rt2=${endName}`;
  };

  const startData = startPoint && startPoint.startInfo;
  const endData = endPoint && endPoint.endInfo;

  useEffect(() => {
    // 셔틀
    const navTempTextObjToShuttleStop = { str: {} };
    const navTempTextObjFromShuttleStop = { str: {} };
    const navTempTextObjShuttle = { str: {} };
    if (i18n.language === "ko-KR") {
      navTempTextObjToShuttleStop.str[i18n.language] =
        t("path.shuttlebusStop") +
        t("path.listitemNavigateWalkWay"); /*"까지 도보 이동"*/

      navTempTextObjFromShuttleStop.str[i18n.language] =
        endPoint.name[i18n.language] +
        t("path.listitemNavigateWalkWay"); /*"까지 도보 이동"*/
    } else if (i18n.language === "en-US") {
      navTempTextObjToShuttleStop.str[i18n.language] =
        t("path.listitemNavigateWalkWay") + t("path.shuttlebusStop");

      navTempTextObjFromShuttleStop.str[i18n.language] =
        t("path.listitemNavigateWalkWay") + endPoint.name[i18n.language];
    }
    /*"셔틀버스 정류장까지 도보 이동"*/
    const kakaoPathToShuttleStop = [
      {
        icon: KakaoIcon,
        str: navTempTextObjToShuttleStop.str,
        btn: "map",
        url: makeKakaoLink(
          startPoint?.coords?.x,
          startPoint?.coords?.y,
          startShuttleInfo?.coords?.x,
          startShuttleInfo?.coords?.y,
          "walk",
          startPoint?.name[i18n.language],
          startShuttleInfo?.name[i18n.language]
        ),
      },
    ];
    /**"{도착지이름}까지 도보 이동" */
    const kakaoPathFromShuttleStop = [
      {
        icon: KakaoIcon,
        str: navTempTextObjFromShuttleStop.str,
        btn: "map",
        url: makeKakaoLink(
          endShuttleInfo?.coords?.x,
          endShuttleInfo?.coords?.y,
          endPoint?.coords?.x,
          endPoint?.coords?.y,
          "walk",
          endShuttleInfo?.name[i18n.language],
          endPoint?.name[i18n.language]
        ),
      },
    ];

    // 대중교통
    const navTempTextObjPublic = { str: {} };
    if (i18n.language === "ko-KR") {
      navTempTextObjPublic.str[i18n.language] =
        endPoint.name[i18n.language] +
        t("path.listitemNavigatePublic"); /*"까지 대중교통 이동"*/
    } else if (i18n.language === "en-US") {
      navTempTextObjPublic.str[i18n.language] =
        t("path.listitemNavigatePublic") + endPoint.name[i18n.language];
    }
    const publicPath = [
      {
        icon: KakaoIcon,
        str: navTempTextObjPublic.str,
        btn: "map",
        url: makeKakaoLink(
          startPoint?.coords?.x,
          startPoint?.coords?.y,
          endPoint?.coords?.x,
          endPoint?.coords?.y,
          "traffic",
          startPoint?.name[i18n.language],
          endPoint?.name[i18n.language]
        ),
      },
    ];
    console.log(publicPath);
    // 도보 (같은 구역)
    const navTempTextObjWalk = { str: {} };
    if (i18n.language === "ko-KR") {
      navTempTextObjWalk.str[i18n.language] =
        endPoint.name[i18n.language] +
        t("path.listitemNavigateWalkWay"); /*"까지 대중교통 이동"*/
    } else if (i18n.language === "en-US") {
      navTempTextObjWalk.str[i18n.language] =
        t("path.listitemNavigateWalkWay") + endPoint.name[i18n.language];
    }
    const walkPath = [
      {
        icon: KakaoIcon,
        str: navTempTextObjWalk.str,
        btn: "map",
        url: makeKakaoLink(
          startPoint?.coords?.x,
          startPoint?.coords?.y,
          endPoint?.coords?.x,
          endPoint?.coords?.y,
          "walk",
          startPoint?.name[i18n.language],
          endPoint?.name[i18n.language]
        ),
      },
    ];

    const startTempTextObj = {};
    startTempTextObj[i18n.language] = `${startPoint.name[i18n.language]}`;

    const makePathList = async () => {
      console.log("tp: ", transport);
      const _pathDetails = [];
      if (transport === "shuttle") {
        // 셔틀버스 이동 관련 타일 추가
        navTempTextObjShuttle.str[i18n.language] =
          endShuttleInfo.name[i18n.language] +
          t("path.listitemNavigateShuttle");

        const shuttlePath = [
          {
            icon: ShuttleIcon,
            str: navTempTextObjShuttle.str,
            btn: "",
          },
        ];

        if (startPoint.region === "북구") {
          shuttlePath[0].btn = "shuttle-info-A";
        } else if (startPoint.region === "동구") {
          shuttlePath[0].btn = "shuttle-info-B";
        } else if (startPoint.region === "남구") {
          shuttlePath[0].btn = "shuttle-info-C";
        } else if (startPoint.region === "서구") {
          shuttlePath[0].btn = "shuttle-info-D";
        }

        if (
          startPoint.name["ko-KR"] === "A 비엔날레 전시관" ||
          startPoint.name["ko-KR"] === "B 국립아시아문화전당" ||
          startPoint.name["ko-KR"] === "C 양림역사문화마을" ||
          startPoint.name["ko-KR"] === "D 유스퀘어 터미널"
        ) {
          // 셔틀정류장까지 걸어가는 설명 타일 빼기
          _pathDetails.push({
            icon: StartPoint,
            str: startTempTextObj,
            btn: "",
          });
          _pathDetails.push(...shuttlePath);
          _pathDetails.push(...kakaoPathFromShuttleStop);
          _pathDetails.push(...endData);
          _pathDetails.push({ icon: EndPoint, str: endPoint.name });
        } else {
          // 셔틀정류장까지 걸어가는 설명 타일 추가

          _pathDetails.push({
            icon: StartPoint,
            str: startTempTextObj,
            btn: "",
          });
          _pathDetails.push(...startData);
          _pathDetails.push(...kakaoPathToShuttleStop);
          _pathDetails.push(...shuttlePath);
          _pathDetails.push(...kakaoPathFromShuttleStop);
          _pathDetails.push(...endData);

          _pathDetails.push({ icon: EndPoint, str: endPoint.name });
        }
      } else if (transport === "public") {
        console.log(1);
        // 대중교통 길안내
        _pathDetails.push({
          icon: StartPoint,
          str: startTempTextObj,
          btn: "",
        });
        console.log(2);

        if (
          !(
            startPoint.name["ko-KR"] === "A 비엔날레 전시관" ||
            startPoint.name["ko-KR"] === "B 국립아시아문화전당" ||
            startPoint.name["ko-KR"] === "C 양림역사문화마을" ||
            startPoint.name["ko-KR"] === "D 유스퀘어 터미널"
          )
        ) {
          _pathDetails.push(...startData);
          console.log(3);
        }

        _pathDetails.push(...publicPath);
        console.log(4);

        _pathDetails.push(...endData);
        console.log(5);

        _pathDetails.push({ icon: EndPoint, str: endPoint.name });
        console.log("_p: ", _pathDetails);
      } else if (transport === "walk") {
        // 도보 길안내
        _pathDetails.push({
          icon: StartPoint,
          str: startTempTextObj,
          btn: "",
        });
        _pathDetails.push(...startData);

        _pathDetails.push(...walkPath);
        _pathDetails.push(...endData);
        _pathDetails.push({ icon: EndPoint, str: endPoint.name });
      } else {
      }
      setPathDetails(_pathDetails);
    };
    console.log("test");
    if (startShuttleInfo !== undefined && endShuttleInfo !== undefined) {
      console.log("test2");
    }
    try {
      makePathList();
    } catch {}
  }, [endShuttleInfo, startShuttleInfo]);

  // const kakaoLink = `https://m.map.kakao.com/actions/walkRoute?startLoc=${startPoint.name[i18n.language]}&sxEnc=${startPoint.coords?.xEnc}&syEnc=${startPoint.coords?.yEnc}&endLoc=${endPoint.name[i18n.language]}&exEnc=${endPoint.coords?.xEnc}&eyEnc=${endPoint.coords?.yEnc}&ids=P${startPoint.id},P${endPoint.id}&service=`;

  return (
    <div>
      <div
        style={{
          position: "fixed",
          display: "flex",

          zIndex: 1,
          top: 16,
          left: 16,
          inset: "auato 0 0 auto",
        }}
      >
        <Link to="/detail">
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: 0,
            }}
          >
            <img src={ArrowBack} alt="" />
          </button>
        </Link>
      </div>

      <div
        style={{
          // zIndex: 3,
          position: " absolute",
          top: 0,
          left: 0,
          // width: "100%",
          height: "100%",
          backgroundColor: "white",
          padding: "16px",
          color: "#282D4B",

          // overflow: "hidden",
        }}
      >
        <div
          style={{
            fontSize: "22px",
            lineHeight: "29px",
            padding: "44px 6px 20px",
          }}
        >
          {i18n.language === "en-US" && t("path.headerText2") + " "}
          <span style={{ color: "#477AE9" }}>
            {endPoint.name[i18n.language]}
          </span>
          {i18n.language === "ko-KR" && t("path.headerText1")}
          {i18n.language === "ko-KR" && <br />}
          {i18n.language === "ko-KR" && t("path.headerText2")}
        </div>
        <div
          style={{
            display: "flex",
            textAlign: "center",
            lineHeight: "18px",
            padding: "13px 0",
            width: "calc(100vw - 32px)",
            backgroundColor: "#F0F6FE",
            borderRadius: "8px",
            marginBottom: "6px",
            fontSize: "14px",
          }}
        >
          <div style={{ paddingLeft: "8px", width: "45%", margin: "auto" }}>{`${
            startPoint.name[i18n.language]
          }`}</div>
          <div style={{ width: "10%", margin: "auto" }}>
            <img
              src={ArrowEast}
              alt="to"
              style={{
                padding: "0 8px",
                position: "relative",
                top: "2px",
              }}
            />
          </div>
          <div style={{ paddingRight: "8px", width: "45%", margin: "auto" }}>
            {endPoint.name[i18n.language]}
          </div>
        </div>
        <PathList pathDetails={pathDetails} />
      </div>

      {isMapVisible && (
        <>
          <div
            style={{
              position: "fixed",
              display: "flex",
              zIndex: 1,
              top: 0,
              left: 0,

              background: "black",
              opacity: "0.5",
              width: "100%",
              height: "100%",
            }}
          ></div>

          <div
            style={{
              position: "fixed",
              display: "flex",
              width: "100vw",
              height: height,
              maxHeight: "911px",
              borderRadius: "12px 12px 0 0",

              zIndex: 1,
              bottom: 0,
              // inset: "auto 0 0 auto",
              backgroundColor: "#ffffff",
              color: "#423630",
              alignItems: "center",
              justifyContent: "center",
              left: 0,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 20,
                left: 16,
                fontSize: "18px",
                color: "#282D4B",
              }}
            >
              {description}
            </div>
            <button
              onClick={(e) => setIsMapVisible(false)}
              style={{
                position: "absolute",
                top: 20,
                right: 16,
                backgroundColor: "transparent",
                border: "none",
                padding: "0",
              }}
            >
              <img src={DeleteMiniMap} alt="" />
            </button>

            <object
              id="minimap"
              type="image/svg+xml"
              data={minimap}
              style={{
                bottom: 40,
                position: "absolute",
                width: `${window.innerWidth - 32}px`,
                maxWidth: "700px",
              }}
            >
              <img src={minimap} alt="" />
            </object>
          </div>
        </>
      )}
    </div>
  );
};

export default Path;
